import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { items } from "@recoil/Store";
import React from "react";
import { useRecoilState, } from "recoil";
import * as Const from "@utils/Const";
import MenuTree from "./MenuTree";
import MenuView from "./MenuView";
import MenuUpdate from "./MenuUpdate";
import MenuCreate from "./MenuCreate";
export default function MenuMain() {
    const [item, setItem] = useRecoilState(items);
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ className: "admin-body" }, { children: [item && _jsx(MenuTree, { item: item, setItem: setItem }), (item && item.type === Const.TYPE_V) && (item.tab === Const.AD_M) &&
                    _jsx(MenuView, { item: item, setItem: setItem }), (item && item.type === Const.TYPE_C) && (item.tab === Const.AD_M) &&
                    _jsx(MenuCreate, { item: item, setItem: setItem }), (item && item.type === Const.TYPE_P) && (item.tab === Const.AD_M) &&
                    _jsx(MenuUpdate, { item: item, setItem: setItem })] })) }));
}
